import { render, staticRenderFns } from "./FormNote.vue?vue&type=template&id=7d0fb2bf&"
import script from "./FormNote.vue?vue&type=script&lang=js&"
export * from "./FormNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports